import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=7df830cf&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"
import style0 from "./Performance.vue?vue&type=style&index=0&id=7df830cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df830cf",
  null
  
)

export default component.exports